export const magicNumbers = {
  bottomBarHeight: 50,
  mainActionsBarHeight: 61,
};
